/**
 * Game configuration constants
 */
export const GAME_CONFIG = {
  /** Minimum bet amount in cents */
  MIN_BET: 10,
  /** Maximum bet amount in cents */
  MAX_BET: 100000,
  /** Default auto-cashout multiplier */
  DEFAULT_AUTO_CASHOUT: 2.0,
  /** Maximum crash history entries to display */
  CRASH_HISTORY_SIZE: 20,
  /** FPS target for 3D scene */
  TARGET_FPS: 60,
} as const;

/**
 * Theme colors (matching Tailwind config)
 */
export const COLORS = {
  aviatorSky: '#87ceeb',
  aviatorSkyDark: '#1e3a5f',
  aviatorCloud: '#ffffff',
  aviatorPlane: '#dc2626',
  aviatorPlaneAccent: '#b91c1c',
  aviatorRunway: '#374151',
  aviatorGold: '#fbbf24',
  aviatorSuccess: '#22c55e',
  aviatorDanger: '#ef4444',
} as const;

/**
 * Animation durations in milliseconds
 */
export const ANIMATION = {
  TAKEOFF: 2000,
  PROPELLER_SPIN: 100,
  CLOUD_DRIFT: 20000,
  CRASH_EXPLOSION: 500,
  UI_TRANSITION: 200,
} as const;
